import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "social-media";

export type listSocialMedia = {
    keyword?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    page?: number;
    sortBy?: string;
    sortType?: string;
}

export type socialMediaType = {
    social_media_name: string;
    social_media_link: string;
}

export class SocialMediaApi extends BaseAPI {
    static getList(query: listSocialMedia): Promise<AxiosResponse> {
        return this.api.get(`${path}`, { params: { ...query } })
    }
    static update(id_social_media: number, body: socialMediaType): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_social_media}`, body)
    }
}